import { collection, getCountFromServer, query, where } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import { Dayjs } from "dayjs";
import countScheduledMessages from "../jobs/countScheduledMessages";

async function getOverviewPeriodStats(date: Dayjs): Promise<{
  currentJobsCount: number;
  currentSmsCount: number;
  currentNotificationsCount: number;
}> {
  try {
    const db = firestore;
    const smsCollection = collection(db, FirestoreCollections.sms);
    const notificationsCollection = collection(db, FirestoreCollections.notifications);

    const beginningOfTheDay = date.startOf('day');
    const endOfTheDay = date.endOf('day');

    // Run all queries in parallel
    const [
      currentSmsSnapshot,
      currentScheduledMessagesCount,
      currentNotificationsSnapshot

    ] = await Promise.all([
      getCountFromServer(query(smsCollection, where("created", ">", beginningOfTheDay.valueOf()), where("created", "<", endOfTheDay.valueOf()))),
      countScheduledMessages([where("timestamp", ">", beginningOfTheDay.valueOf()), where("timestamp", "<", endOfTheDay.valueOf())]),
      getCountFromServer(query(notificationsCollection, where("created", ">", beginningOfTheDay.valueOf()), where("created", "<", endOfTheDay.valueOf())))
    ]);

    return {
      currentJobsCount: currentScheduledMessagesCount,
      currentSmsCount: currentSmsSnapshot.data().count ?? 0,
      currentNotificationsCount: currentNotificationsSnapshot.data().count ?? 0,
    };
  } catch (e) {
    console.log("error: ", e);
    throw new GetOverviewPeriodStatsFailure();
  }
}

export class GetOverviewPeriodStatsFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default getOverviewPeriodStats;
